import { ButtonTertiary } from "c4u-web-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { paths } from "../../../constants";
import { useRenave } from "../../../hooks";
import {
  GetDocumentRequest,
  IDownloadDocumentModel,
  TypeDocumentCodeEnum,
} from "../../../models";
import { CardDownloadDocumentMolecule } from "../../molecules";
import { ButtonWrapper } from "../shared-style/organisms.shared-style";
import { VehicleCheckedInContentWrapper } from "./vehicle-checked-out.organism.style";

export const VehicleCheckedOutOrganism: React.FC = () => {
  const { t } = useTranslation();
  const { getDocument } = useRenave();
  const params = useParams<{ id: string }>();
  const history = useHistory();

  const downloadDocuments: IDownloadDocumentModel[] = [
    {
      title: t("ExitTermRenave"),
      icon: "checked",
      text: t("DocumentGeneratedIn"),
      typeDocumentCode: TypeDocumentCodeEnum.ExitTerm,
    },
    {
      title: t("ExitAtvp"),
      icon: "checked",
      text: t("DocumentGeneratedIn"),
      typeDocumentCode: TypeDocumentCodeEnum.ExitATPV,
    },
  ];

  return (
    <>
      <VehicleCheckedInContentWrapper>
        {downloadDocuments.map((m, i) => (
          <CardDownloadDocumentMolecule
            key={`download-doc-card-${i}`}
            iconName={m.icon}
            title={m.title}
            text={m.text}
            onClickGetDocument={() =>
              getDocument(
                new GetDocumentRequest({
                  id: Number(params.id),
                  typeDocumentCode: m.typeDocumentCode,
                })
              )
            }
          />
        ))}
      </VehicleCheckedInContentWrapper>

      <ButtonWrapper>
        <ButtonTertiary
          sizex="md"
          onClick={() => {
            history.push(paths.home());
          }}
        >
          {t("Finish")}
        </ButtonTertiary>
      </ButtonWrapper>
    </>
  );
};
